const MIN_DESKTOP_WIDTH = 767;

export function isMobile() {
  const isMobileWidth = window.innerWidth < MIN_DESKTOP_WIDTH;
  return isMobileWidth;
}
